module.exports = __webpack_public_path__ + "static/media/pic1_trial.44b3834f.png";